import { useState } from "react";
import { Flame, X, MapPin } from "lucide-react";

const SpotItem = ({ spot, onClick }) => (
  <button
    data-testid="hotspot-item"
    onClick={onClick}
    className="block w-full text-left px-5 py-3.5 hover:bg-white/10 transition-colors border-b border-white/5 last:border-0"
  >
    <div className="flex items-center gap-2">
      <MapPin size={13} className="text-[#2ec4b6] shrink-0" />
      <span className="text-sm font-semibold text-white">{spot.name}</span>
      <span className="text-xs text-zinc-300 ml-auto shrink-0">{spot.region}</span>
    </div>
    <p className="text-xs text-zinc-300 mt-1 line-clamp-2 leading-snug">{spot.description}</p>
    <div className="flex gap-1.5 mt-1.5 flex-wrap">
      {spot.best_for.map((t) => (
        <span key={t} className="text-[10px] px-2 py-0.5 rounded-full bg-[#2ec4b6]/15 text-[#2ec4b6] font-medium">{t}</span>
      ))}
    </div>
  </button>
);

export const HotSpots = ({ spots, onSelect }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="hotspots-toggle"
        onClick={() => setOpen(!open)}
        className="absolute bottom-6 left-4 md:left-[420px] z-[510] flex items-center gap-2 bg-black/70 backdrop-blur-xl border border-[#2ec4b6]/40 rounded-full px-4 py-2.5 text-sm font-heading font-semibold text-[#2ec4b6] hover:bg-[#2ec4b6]/15 transition-colors shadow-2xl"
      >
        <Flame size={16} /> Hot Spots
      </button>
      {open && (
        <div
          data-testid="hotspots-panel"
          className="absolute bottom-20 left-4 md:left-[420px] z-[510] w-[320px] max-h-[55vh] flex flex-col bg-black/80 backdrop-blur-2xl border border-white/15 rounded-3xl shadow-2xl overflow-hidden"
        >
          <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
            <div>
              <p className="font-heading font-bold text-base text-white">Best Flying Spots</p>
              <p className="text-xs text-zinc-300 mt-0.5">Pilot-favourite legal locations across the UK</p>
            </div>
            <button data-testid="hotspots-close" onClick={() => setOpen(false)} className="text-zinc-300 hover:text-white transition-colors">
              <X size={18} />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto">
            {spots.map((s) => (
              <SpotItem
                key={s.name}
                spot={s}
                onClick={() => {
                  onSelect(s);
                  setOpen(false);
                }}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
